import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "Audios/bt_fpt_ai/danh_tu_bt1.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page11/Key/E1answerKey.png",
    titleQuestion: [
      {
        num: "1.",
        title: "Xếp các từ trong bông hoa vào nhóm thích hợp.",
        color: "rgb(3, 103, 181)",
      },
    ],
    component: MatchDots,
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `
        <span>Em làm bài bằng cách bấm chuột vào bông hoa, sau đó bấm chuột vào chiếc giỏ thích hợp.
        </span><p></p>
        <p >Cách xóa đường đã nối: Em hãy bấm chuột lần nữa vào bông hoa và chiếc giỏ đã bấm chuột trước đó.</p>
        <video  src="Audios/Huong dan/p16-e1.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "105px",
              left: "208px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //0
          {
            boxMatchStyle: {
              position: "absolute",
              top: "121px",
              left: "505px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "109px",
              left: "836px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //2

          {
            boxMatchStyle: {
              position: "absolute",
              top: "259px",
              left: "114px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "279px",
              left: "504px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "903px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //5

          {
            boxMatchStyle: {
              position: "absolute",
              top: "429px",
              left: "192px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "447px",
              left: "506px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //7
          {
            boxMatchStyle: {
              position: "absolute",
              top: "429px",
              left: "833px",
              width: 129,
              height: 129,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //8
        ],
        answers: ["0-7", "1-6", "3-4", "4-5", "2-7", "1-8"],
        initialValue: [],
      },
      Layout: `
        <div style='display:flex;font-size:24px'>
          <img src='/img/FriendsPlus/Page11/E1/3.jpg' style='height:15cm' />
        </div>
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
          <input id='8' type= 'boxMatch' />
          
      `,
    },
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "Audios/bt_fpt_ai/danh_tu_bt2.mp3",
    video: "",
    autoPlay: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page11/Key/E2answerKey.png",
    titleQuestion: [
      {
        num: "2.",
        title: "<span>Nối mỗi phong thư với hộp thư phù hợp.</span> ",
        color: "rgb(3, 103, 181)",
      },
    ],
    component: MatchDots,
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `
        <span>Em hãy bấm chuột vào phong thư, sau đó bấm chuột vào hộp thư thích hợp.
        </span><p></p>
        <p >Cách xóa đường đã nối: Em hãy bấm chuột lần nữa vào phong thư và hộp thư đã bấm chuột trước đó.</p>  
        <video  src="Audios/bt_fpt_ai/guide/p18_e2.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "231px",
              left: "82px",
              width: 181,
              height: 250,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //0
          {
            boxMatchStyle: {
              position: "absolute",
              top: "221px",
              left: "742px",
              width: 181,
              height: 250,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //1

          {
            boxMatchStyle: {
              position: "absolute",
              top: "115px",
              left: "417px",
              width: 264,
              height: 76,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "208px",
              left: "423px",
              width: 312,
              height: 54,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "279px",
              left: "418px",
              width: 203,
              height: 54,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "354px",
              left: "417px",
              width: 203,
              height: 54,
              //backgroundColor: "blue",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //5
        ],
        answers: ["0-3", "0-4", "1-2", "1-5"],
        initialValue: [],
      },
      Layout: `
        <div style='font-size:25px;color:black'>
          
          <b style=' color:rgb(190 95 69)'>G</b>: Mỗi phong thư ghi nội dung hoặc cách viết của nhóm thư trên hộp thư A hoặc B.
        </div>
        <div style='font-size:24px'>
          <img src='/img/FriendsPlus/Page11/E2/1.jpg' style='height:105mm;margin-left:-80px' />
        </div>
          <img src='/img/FriendsPlus/Page11/E2/3.jpg' style='height:50mm' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          
          
      `,
    },
  },
};

export default json;
